namespace $.$$ {

	export class $shm_dashboard_app_dashboard_list extends $.$shm_dashboard_app_dashboard_list {

		dashboard_models() {
			return this.$.$shm_ba_dashboard_model.list()
		}

		dashboard_id( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'dashboard', next === 'default' ? null : next )
				return next
			}

			const id = this.$.$mol_state_arg.value( 'dashboard' ) ?? this.dashboard_models()[0]?.id() ?? 'default'
			return this.dashboard_models().some( dashboard => dashboard.id() === id ) ? id : 'default'
		}

		dashboard_model() {
			const id = this.dashboard_id()
			return this.dashboard_models().find( dashboard => dashboard.id() === id ) ?? this.dashboard_models()[0] ?? null
		}

		dashboard_rows() {
			return this.dashboard_models_filtered().map( dashboard => this.Dashboard_link( dashboard.id() ) )
		}

		search_showed() {
			return this.dashboard_models().length >= 10
		}

		dashboard_models_filtered() {
			const dashboards = this.dashboard_models()
			if( !this.search_showed() ) return dashboards

			const query = this.filter().trim().toLowerCase()
			if( !query ) return dashboards

			return dashboards.filter( dashboard => dashboard.title().toLowerCase().includes( query ) )
		}

		dashboard_filter_id( id: string ) {
			return this.$.$mol_state_local.value< string >( `hitalama_ba_filter_last:${ id }` ) || null
		}

		dashboard_arg( id: string ) {
			return {
				section: 'mentions',
				dashboard: id === 'default' ? null : id,
				report: null,
				ba_filter_id: this.dashboard_filter_id( id ),
				wordstat_task: null,
				wordstat_filter_id: null,
			}
		}

		dashboard_title( id: string ) {
			return this.dashboard_models().find( dashboard => dashboard.id() === id )?.title() ?? id
		}

		dashboard_current( id: string ) {
			const section = this.$.$mol_state_arg.value( 'section' ) ?? 'mentions'
			if( section === 'settings' ) return false
			return this.dashboard_id() === id
		}

	}

}
